import { $http } from "@/assets/js/appFunc";
import Vue from "vue";
import i18n from "@/i18n/index";

export const getDocumentsList = (store) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const req = {
        url: `/design/documents/templates?applicationId=${applicationId}`,
        type: "GET",
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
                store.commit("setDocumentList", data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getDocumentTemplate = (store, id) => {
    const req = {
        type: "GET",
        url: `/documents/templates/${id}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
                store.commit("setCurrentTemplate", data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const postNewDocument = (store, doc) => {
    const req = {
        type: "POST",
        url: "/design/documents/persist",
        data: doc
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(rsp => {
            store.commit("setDocumentList", store.state.existingDocs);
            store.commit("setCommitId", rsp.data.commitId);
            resolve(rsp);
        }).catch(error => {
            reject(error);
        });
    });
};

export const saveDocumentsListName = (store, docList) => {
    const req = {
        type: "POST",
        url: "/design/documents/rename",
        data: docList
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                store.commit("setDocumentList", store.state.existingDocs);
                store.commit("setCommitId", data.data.commitId);
                resolve(data.data);
            },
            error => reject(error)
        );
    });
};

export const deleteDocument = (store, doc) => {
    const req = {
        type: "DELETE",
        url: `/design/documents/${doc.id}`,
        data: doc,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
                store.commit("setDeleteDocument", doc.id);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const saveDocumentImageUploaded = (store, data) => {
    const imageUploadedPromise = new Promise((resolve, reject) => {
        const
            cb = () => {
                $http(
                    {
                        // url: `/appfile/documentImages`,
                        url: `/documents/templates/${store.state.selectedDoc[0].id}/image/upload/`,
                        type: "POST",
                        data,
                        headers: { "Content-Type": "multipart/form-data" }
                    }, true
                )
                    .then(rsp => {
                        const dataPlugin = {
                            fileUUID: rsp.data && rsp.data.fileUUID ? rsp.data.fileUUID : null,
                            fileURL: rsp.data && rsp.data.fileURL ? rsp.data.fileURL : null
                        };
                        resolve(dataPlugin);
                    })
                    .catch(e => {
                        reject(e);
                    });
            };
        if (store.state.selectedDoc[0].hasOwnProperty("isNew")) {
            store.dispatch("postNewDocument").then(() => {
                cb();
            });
        } else {
            cb();
        }
    });
    return imageUploadedPromise;
};
export const postDocumentTemplate = (store, docToSend) => {
    $http({
        type: "POST",
        url: "/documents/templates/preview",
        data: {
            doc: docToSend.objToSend, type: docToSend.docType ? "PDF" : "DOCX"
        },
        responseType: "arraybuffer",
        noNotify: true
    }, true).then(rsp => {
        const newBlob = new Blob([rsp.data], { type: docToSend.docType ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = docToSend.docType ? docToSend.name : `${docToSend.name}.docx`;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
        document.body.removeChild(link);
    }).catch(error => {
        const errorData = JSON.parse(Buffer.from(error.response.data).toString("utf8"));
        let message = errorData.error;
        if (errorData.error.includes("list attribute outside of")) {
            message = i18n.t("froala.failedPreview");
        }
        Vue.prototype.$toast.showNotify({
            type: "error",
            message
        });
        console.error(errorData);
    });
};

export const generateExcel = (store, inputData) => new Promise(() => {
    $http({
        url: "/documents/generic/excel/generate",
        type: "POST",
        data: inputData,
        responseType: "arraybuffer",
        headers: {
            "Content-type": "application/json;charset=UTF-8",
            Accept: "application/octet-stream"
        }
    }, true).then(rsp => {
        const url = window.URL.createObjectURL(new Blob([rsp.data], { type: "application/octet-stream" }));
        const link = document.createElement("a");
        link.href = url;
        // eslint-disable-next-line prefer-destructuring
        link.download = rsp.headers["content-disposition"].split("=")[1];
        document.body.appendChild(link);
        link.click();
    }).catch(e => {
        console.log(e);
    });
});

export const getDocCommitId = (store, documentId) => {
    const appId = store.rootState.apps.currentApp.id;

    const req = {
        url: `/design/app/${appId}/documents/${documentId}/last-commit-id`,
        type: "GET"
    };
    return $http(req, true).then(
        data => data,
        error => error
    );
};

export const getDocumentDetails = (store, documentId) => {
    const req = {
        url: `/design/documents/templates/${documentId}`,
        type: "GET"
    };
    return $http(req, true).then(
        data => data,
        error => error
    );
};

export const getDocumentHistoryPreviewData = (store, payload) => {
    const req = {
        url: "/design/documents/templates/preview",
        type: "POST",
        data: payload
    };
    return $http(req, true);
};

export const recoverDocument = (store, payload) => {
    const params = {
        url: "/design/documents/recover",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
};
